import React from 'react';
import Header from '../components/Header/header';
import publications from '../images/covers/publications.jpg';
import Collaborator from "../components/Collaborator/collaborator";

export default ({ data }) => {


  let sponsors = [];
  let collaborators = [];

  data.allContentfulCollaborators.edges.map(( { node } ) => {
    if (node.sponsor) {
      sponsors.push(node)
    }
    else {
      collaborators.push(node)
    }
  });

  let sponsorImages = sponsors.map((sponsor, index) => {
    return <Collaborator name={sponsor.name} logo={sponsor.logo.file.url} sponsor={true} url={sponsor.link}/>
  });

  let collaboratorImages = collaborators.map((collab, index) => {
    return <Collaborator name={collab.name} logo={collab.logo.file.url} sponsor={false} url={collab.link}/>
  });


  return (
    <div className="team">
      <Header
        image={publications}
        title={"NANOTECH LAB | YUSHIN GROUP"}
        subtitle={"Collaborators and Sponsors"}
      />

      <section className={"grey"}>
        <div className={"container sponsors"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">Sponsors</h2>
          </div>
          <div className={"row"}>
            {sponsorImages}
          </div>
        </div>
      </section>

      <section>
        <div className={"container collaborators"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">Collaborators</h2>
          </div>

          <div className={"row"}>
            {collaboratorImages}
          </div>
        </div>
      </section>


    </div>
  );
};

export const query = graphql`
  query CollaboratorQuery {
    allContentfulCollaborators(sort:{fields: [sponsor], order:DESC}) {
      edges {
        node {
          id
          name
          sponsor
          link
          logo {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/collaborators.js